const config = {
  environment: 'staging',
  integrationUrl: 'https://web.onboarding.staging.multilog24.de/',
};

export default config;
